import { HttpCommunicator, Container } from '@ivorobioff/shared';

const NOTES_BY_PLAN: Record<string, string[]> = {

  // Жрачка
  '65195ab60263d52122941182': [
    'Auchan',
    'Kaufland',
    'Lidl',
    'Selgros',
    'Рынок',
    'McDonald\'s',
    'Burger King',
    'KFC',
    'Mesopotamia',
    'Carrefour',
    'Mega Image',
    'Profi',
    'Taco Bell'
  ],

  // Прочее
  '652556650263d521229411b3': [
    'Hornbach',
    'Dedeman',
    'Auchan',
    'Kaufland',
    'Lidl',
    'Carrefour',
    'Selgros',
  ],

  // Бензин
  '6640f8e1cd54065364ca542e': [
    'e-Charge',
  ],
};

export class NoteService {

  private http: HttpCommunicator;

  constructor(container: Container) {
    this.http = container.get('https');
  }

  async getAll(planId: string): Promise<string[]> {
    return Promise.resolve(NOTES_BY_PLAN[planId] ?? []);
  }
}
